export default function() {
  const tabButton = $(".partners-tabs .partners-tabs__header .partners-tabs__header-item");
  const tabContent = $(".partners-tabs .partners-tabs__content .partners-tabs__content-item");

  const tabActive = "partners-tabs__header-active"
  const contentActive = "partners-tabs__content-active"

  $(tabButton).click(function () {
    const tabItem = $(tabContent);
    $(tabButton).removeClass(tabActive);
    $(this).addClass(tabActive);

    $(tabContent).removeClass(contentActive);
    for (let i = 0; i < tabItem.length; i++) {
      if ($(tabItem[i]).attr("data-tab") === $(this).attr("data-tab"))
        $(tabItem[i]).addClass(contentActive);
    }
  });
}